"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// import ReactDOM from 'react-dom';
var moment_1 = __importDefault(require("moment"));
var ACWrapperContext_1 = require("../Components/ACWrapperContext");
var sampleSlice_1 = require("../redux/slice/sampleSlice");
// import { CONSTANTS } from '../utils/app-constants';
var react_toastify_1 = require("react-toastify");
var ACWrapperContext_2 = require("../Components/ACWrapperContext");
// import react,{ useContext } from 'react';
// import { RefContext } from '../context/RefProvider';
var utils_1 = require("../utils");
var helpers_1 = require("../utils/helpers");
// interface ExtendedReactToPrintOptions extends UseReactToPrintOptions {
//   content?: () => HTMLElement | null;
// }
// const { BASE_URL, FAILURE_MSG, CATCH_ERROR_MSG, AUTO_CLOSE } = CONSTANTS;
// const BASE_URL = 'http://localhost:3001';
// Don't initialize at module level - will get it when needed
// const makeApiCall = getMakeApiCall();
// const Utils = getUtils() as UtilsType;
// Store debounce timers with keys as stateId strings
var changeStateDebounceTimers = {};
var globalHandlers = {
    changeActiveTab: function (args, context) {
        var _a, _b;
        var store = (0, ACWrapperContext_1.getStore)();
        var state = store === null || store === void 0 ? void 0 : store.getState();
        try {
            var activeTabStoredLocation = args.activeTabStoredLocation, tabsStoredLocation = args.tabsStoredLocation, rootState = args.rootState, _c = args.optionValueKey, optionValueKey_1 = _c === void 0 ? 'key' : _c, _d = args.direction, direction = _d === void 0 ? 'next' : _d;
            // Validate required parameters
            if (!args || !tabsStoredLocation) {
                console.log("changeState: Missing required parameter 'tabsStoredLocation'");
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return;
            }
            if (!args || !activeTabStoredLocation) {
                console.log("changeState: Missing required parameter 'activeTabStoredLocation'");
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return;
            }
            if (!rootState) {
                console.log("__redux state changeState: Missing required parameter 'rootState'");
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return;
            }
            if (!context) {
                console.error('changeState: Context is undefined or null');
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return;
            }
            // Check if dispatch function exists
            if (typeof context.dispatch !== 'function') {
                console.error('changeState: context.dispatch is not a function');
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return;
            }
            var tabs_1 = helpers_1.Helper.getNestedValue((_a = state === null || state === void 0 ? void 0 : state.dynamic) === null || _a === void 0 ? void 0 : _a[rootState], tabsStoredLocation);
            var activeTab_1 = helpers_1.Helper.getNestedValue((_b = state === null || state === void 0 ? void 0 : state.dynamic) === null || _b === void 0 ? void 0 : _b[rootState], activeTabStoredLocation);
            var toggle = function (direction) {
                var _a;
                var currentIndex = tabs_1.findIndex(function (e) { return (e === null || e === void 0 ? void 0 : e[optionValueKey_1]) === activeTab_1; });
                if (direction === 'next') {
                    activeTab_1 = currentIndex + 1;
                    activeTab_1 = activeTab_1 >= tabs_1.length ? 0 : activeTab_1;
                }
                else {
                    activeTab_1 = currentIndex - 1;
                    activeTab_1 = activeTab_1 < 0 ? 0 : activeTab_1;
                }
                activeTab_1 = (_a = tabs_1 === null || tabs_1 === void 0 ? void 0 : tabs_1[activeTab_1]) === null || _a === void 0 ? void 0 : _a[optionValueKey_1];
            };
            toggle(direction);
            context.dispatch((0, sampleSlice_1.setStateValue)({
                path: "".concat(rootState, ".").concat(activeTabStoredLocation),
                value: activeTab_1,
            }));
        }
        catch (error) {
            console.error('changeState: Unexpected error in function execution:', error);
            react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
        }
    },
    scrollToTop: function () {
        var body = document.querySelector('[data-scroll-target="ui-builder-parent"]');
        if (body) {
            body.scrollIntoView({ behavior: 'smooth' });
        }
    },
    setNestedValue: function (args, context) {
        var store = (0, ACWrapperContext_1.getStore)();
        var state = store;
        try {
            var obj = args.obj, path = args.path, value = args.value;
            if (!path || !obj) {
                console.error('setNestedValue: Missing required parameters - path or obj is empty or undefined');
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return obj;
            }
            var parts = path.split('.');
            var newObj = __assign({}, obj);
            var current = newObj;
            for (var i = 0; i < parts.length - 1; i++) {
                var part = parts[i];
                try {
                    var arrayMatch = part.match(/(\w+)\[(\d+)\]/);
                    if (arrayMatch) {
                        var prop = arrayMatch[1], index = arrayMatch[2];
                        var idx = parseInt(index, 10);
                        if (isNaN(idx)) {
                            console.error("setNestedValue: Invalid array index in path part: ".concat(part));
                            react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                            return obj;
                        }
                        // Handle case where property doesn't exist yet or isn't an array
                        if (!current[prop] || !Array.isArray(current[prop])) {
                            current[prop] = [];
                        }
                        // Handle case where array index is out of bounds
                        if (idx < 0) {
                            console.error("setNestedValue: Negative array index in path part: ".concat(part));
                            react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                            return obj;
                        }
                        current[prop][idx] = current[prop][idx] || {};
                        current = current[prop][idx];
                    }
                    else {
                        current[part] = current[part] || {};
                        current = current[part];
                    }
                }
                catch (error) {
                    console.error("setNestedValue: Error processing path part: ".concat(part, " at index ").concat(i), error);
                    react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                    return obj;
                }
            }
            try {
                var lastPart = parts[parts.length - 1];
                var arrayMatch = lastPart.match(/(\w+)\[(\d+)\]/);
                if (arrayMatch) {
                    var prop = arrayMatch[1], index = arrayMatch[2];
                    var idx = parseInt(index, 10);
                    if (isNaN(idx)) {
                        console.error("setNestedValue: Invalid array index in last path part: ".concat(lastPart));
                        react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                        return obj;
                    }
                    // Handle case where property doesn't exist yet or isn't an array
                    if (!current[prop] || !Array.isArray(current[prop])) {
                        current[prop] = [];
                    }
                    // Handle case where array index is out of bounds
                    if (idx < 0) {
                        console.error("setNestedValue: Negative array index in last path part: ".concat(lastPart));
                        react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                        return obj;
                    }
                    current[prop][idx] = value;
                }
                else {
                    current[lastPart] = value;
                }
            }
            catch (error) {
                console.error('setNestedValue: Error setting value at final path segment', error);
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return obj;
            }
            return newObj;
        }
        catch (error) {
            console.error('setNestedValue: Unexpected error in function execution', error);
            react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
            return args.obj || {};
        }
    },
    getState: function (args, context) {
        var _a;
        var store = (0, ACWrapperContext_1.getStore)();
        var state = store === null || store === void 0 ? void 0 : store.getState();
        try {
            // Validate input parameters
            if (!args || !args.storedLocation) {
                console.error("getState: Missing required parameter 'storedLocation'");
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return null;
            }
            if (!args.rootState) {
                console.error("getState: Missing required parameter 'rootState'");
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return null;
            }
            var storedLocation = args.storedLocation, rootState = args.rootState, transform = args.transform;
            // Check if context is available
            // if (!context) {
            //   console.error('getState: Context is undefined or null');
            //   toast.error('An error occurred. Please contact the administrator.');
            //   return null;
            // }
            // // Check if state exists in context
            // if (!context.state) {
            //   console.error('getState: State is undefined in context');
            //   toast.error('An error occurred. Please contact the administrator.');
            //   return null;
            // }
            // // Check if dynamic state exists
            // if (!context.state?.dynamic) {
            //   console.error('getState: Dynamic state is undefined in context');
            //   toast.error('An error occurred. Please contact the administrator.');
            //   return null;
            // }
            // Check if state for rootState exists
            if (!state) {
                console.error("getState: State for rootState '".concat(rootState, "' not found"));
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return null;
            }
            // Get nested value
            var value = helpers_1.Helper.getNestedValue((_a = state === null || state === void 0 ? void 0 : state.dynamic) === null || _a === void 0 ? void 0 : _a[rootState], storedLocation);
            if (value === undefined) {
                console.warn("getState: Path '".concat(storedLocation, "' not found in state for rootState '").concat(rootState, "'"));
            }
            // Apply transform if needed
            if (transform === 'join' && Array.isArray(value)) {
                return value.join(',');
            }
            return value;
        }
        catch (error) {
            console.error('getState: Unexpected error:', error);
            react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
            return null;
        }
    },
    changeState: function (args, context) {
        var store = (0, ACWrapperContext_1.getStore)();
        var state = store === null || store === void 0 ? void 0 : store.getState();
        try {
            // Validate required parameters
            if (!args || !args.storedLocation) {
                console.log("changeState: Missing required parameter 'storedLocation'");
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return;
            }
            if (!args.rootState) {
                console.log("__redux state changeState: Missing required parameter 'rootState'");
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return;
            }
            var storedLocation = args.storedLocation, rootState_1 = args.rootState, value_1 = args.value, debounce = args.debounce, increment = args.increment;
            // console.log('__changeState_called_', args);
            // Validate context
            if (!context) {
                console.error('changeState: Context is undefined or null');
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return;
            }
            // Check if dispatch function exists
            if (typeof context.dispatch !== 'function') {
                console.error('changeState: context.dispatch is not a function');
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return;
            }
            if (increment === true) {
                var currentPath = "".concat(context.rootState, ".").concat(storedLocation);
                var currentValue = helpers_1.Helper.getNestedValue(state.dynamic[context.rootState], storedLocation) || 0;
                context.dispatch((0, sampleSlice_1.setStateValue)({
                    path: currentPath,
                    value: currentValue + 1,
                }));
                return;
            }
            if (value_1 &&
                typeof value_1 === 'object' &&
                value_1.type === 'redux' &&
                value_1.action === 'getState') {
                // Ensure rootState is passed to getState
                var getStateArgs = __assign(__assign({}, (value_1.args || {})), { rootState: rootState_1 });
                value_1 = globalHandlers.getState(getStateArgs, context);
            }
            else if (value_1 &&
                typeof value_1 === 'object' &&
                value_1.type === 'event' &&
                value_1.action === 'getValueFromEvent') {
                var getStateArgs = __assign(__assign({}, (value_1.args || {})), { rootState: rootState_1, event: args === null || args === void 0 ? void 0 : args.event });
                value_1 = globalHandlers.getValueFromEvent(getStateArgs, context);
            }
            if (storedLocation === rootState_1) {
                // Directly set the entire rootState
                context.dispatch((0, sampleSlice_1.setStateValue)({ path: rootState_1, value: value_1 }));
                return;
            }
            // Split the path into parts
            var parts_1 = storedLocation.split('.');
            if (parts_1.length === 0) {
                console.error('changeState: Invalid storedLocation format');
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return;
            }
            // const topLevelKey = parts[0];
            var topLevelKey_1 = parts_1.length > 2 ? parts_1.join('.') : parts_1[0];
            var fullPath_1 = "".concat(rootState_1, ".").concat(topLevelKey_1);
            // Create a unique key for this state change to track the debounce timer
            var debounceKey = "".concat(rootState_1, "_").concat(storedLocation);
            // Create a function that will execute the actual state change
            var executeStateChange = function () {
                var _a, _b;
                // Get current state
                var current;
                try {
                    current = (_b = (_a = state === null || state === void 0 ? void 0 : state.dynamic) === null || _a === void 0 ? void 0 : _a[rootState_1]) === null || _b === void 0 ? void 0 : _b[topLevelKey_1];
                    // If current is undefined or not an object, initialize as empty object
                    // If current is an object (including null), preserve it for merging
                    if (current === undefined ||
                        (current !== null && typeof current !== 'object')) {
                        current = {};
                    }
                    // If current is null, treat it as an empty object
                    if (current === null) {
                        current = {};
                    }
                }
                catch (error) {
                    console.error('changeState: Error accessing current state:', error);
                    react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                    return;
                }
                if (parts_1.length > 1 && parts_1.length <= 2) {
                    // For nested path
                    try {
                        var nestedPath = parts_1.slice(1).join('.');
                        var updated = globalHandlers.setNestedValue({ obj: current, path: nestedPath, value: value_1 }, context);
                        if (updated === current) {
                            console.warn('changeState: setNestedValue did not modify the object');
                        }
                        context.dispatch((0, sampleSlice_1.setStateValue)({ path: fullPath_1, value: updated }));
                    }
                    catch (error) {
                        console.error('changeState: Error updating nested state:', error);
                        react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                        return;
                    }
                }
                else {
                    // For simple path
                    try {
                        context.dispatch((0, sampleSlice_1.setStateValue)({ path: fullPath_1, value: value_1 }));
                    }
                    catch (error) {
                        console.error('changeState: Error dispatching simple state update:', error);
                        react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                        return;
                    }
                }
            };
            // Always execute state changes immediately
            // We now handle debouncing at the effects level, not the state change level
            executeStateChange();
            // Display warning if debounce is specified on changeState
            if (typeof debounce === 'number' && debounce > 0) {
                console.warn("changeState: Debounce value ".concat(debounce, "ms for path ").concat(fullPath_1, " is ignored. Debouncing should be specified on effects handlers instead of changeState. \n        Example:\n        {\n          \"name\": \"effects\",\n          \"handlers\": [\n            {\n              \"action\": \"makeApiCall\",\n              \"args\": {\n                \"api\": {...},\n                \"debounce\": ").concat(debounce, "\n              },\n              \"dependencies\": [\"").concat(storedLocation, "\"]\n            }\n          ]\n        }"));
            }
        }
        catch (error) {
            console.error('changeState: Unexpected error in function execution:', error);
            react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
        }
    },
    getConstantValue: function (args, context) {
        var constants = (0, ACWrapperContext_1.getCONSTANTS)();
        var key = args.key;
        return constants[key] || null;
    },
    makeApiCall: function (args, context) { return __awaiter(void 0, void 0, void 0, function () {
        var store, state, Utils, makeApiCall, api, event_1, rootState_2, loading, store_1, state_1, payload, response, endpoint, _i, _a, _b, key, param, value, functionParam, functionHandler, handlerArgs, handlerArgs, error_1, sanitizedValue, error_2, _loop_1, _c, _d, _e, key, paramConfig, error_3, loaderPath_1, func, loaderPath, error_4, _f, _g, successHandler, handlerFn, nestedValue, handlerValue, error_5, error_6, _h, _j, failureHandler, value, handlerFn, handlerArgs, error_7, loaderPath, error_8;
        return __generator(this, function (_k) {
            switch (_k.label) {
                case 0:
                    store = (0, ACWrapperContext_1.getStore)();
                    state = store;
                    Utils = (0, ACWrapperContext_2.getUtils)();
                    makeApiCall = Utils.makeApiCall;
                    _k.label = 1;
                case 1:
                    _k.trys.push([1, 49, , 50]);
                    // Get makeApiCall function at execution time, not module initialization time
                    if (!makeApiCall) {
                        console.error('makeApiCall: makeApiCall function is not available yet');
                        react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                        return [2 /*return*/, null];
                    }
                    // Validate required parameters
                    if (!args || !args.api) {
                        console.error("makeApiCall: Missing required 'api' parameter");
                        react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                        return [2 /*return*/, null];
                    }
                    api = args.api, event_1 = args.event, rootState_2 = args.rootState, loading = args.loading;
                    store_1 = (0, ACWrapperContext_1.getStore)();
                    if (!store_1) {
                        console.error('makeApiCall: Failed to get store');
                        react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                        return [2 /*return*/, null];
                    }
                    state_1 = store_1;
                    // Validate context and dispatch function
                    if (!context || typeof context.dispatch !== 'function') {
                        console.error('makeApiCall: Invalid context or missing dispatch function');
                        react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                        return [2 /*return*/, null];
                    }
                    payload = {};
                    response = void 0;
                    _k.label = 2;
                case 2:
                    _k.trys.push([2, 39, 47, 48]);
                    // Process API endpoint and parameters
                    if (!api.endpoint) {
                        console.error('makeApiCall: Missing required endpoint in api configuration');
                        react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                        return [2 /*return*/, null];
                    }
                    endpoint = api.endpoint;
                    if (!api.params) return [3 /*break*/, 18];
                    _k.label = 3;
                case 3:
                    _k.trys.push([3, 17, , 18]);
                    _i = 0, _a = Object.entries(api.params);
                    _k.label = 4;
                case 4:
                    if (!(_i < _a.length)) return [3 /*break*/, 16];
                    _b = _a[_i], key = _b[0], param = _b[1];
                    value = void 0;
                    if (!(param && typeof param === 'object')) return [3 /*break*/, 13];
                    functionParam = param;
                    if (!functionParam.action) {
                        console.error("makeApiCall: Missing action in param configuration for ".concat(key));
                        return [3 /*break*/, 15];
                    }
                    functionHandler = globalHandlers[functionParam.action];
                    if (!functionHandler) {
                        console.error("makeApiCall: Handler '".concat(functionParam.action, "' not found for param ").concat(key));
                        return [3 /*break*/, 15];
                    }
                    _k.label = 5;
                case 5:
                    _k.trys.push([5, 11, , 12]);
                    if (!(functionParam.type === 'redux')) return [3 /*break*/, 7];
                    handlerArgs = __assign(__assign({}, functionParam.args), { rootState: rootState_2, event: args.event });
                    return [4 /*yield*/, functionHandler(handlerArgs, context)];
                case 6:
                    value = _k.sent();
                    return [3 /*break*/, 10];
                case 7:
                    if (!(functionParam.type === 'event')) return [3 /*break*/, 9];
                    handlerArgs = __assign(__assign({}, functionParam.args), { event: args.event, rootState: rootState_2 });
                    return [4 /*yield*/, functionHandler(handlerArgs, event_1)];
                case 8:
                    value = _k.sent();
                    return [3 /*break*/, 10];
                case 9:
                    console.warn("makeApiCall: Unknown param type '".concat(functionParam.type, "' for ").concat(key));
                    _k.label = 10;
                case 10: return [3 /*break*/, 12];
                case 11:
                    error_1 = _k.sent();
                    console.error("makeApiCall: Error executing handler for param ".concat(key, ":"), error_1);
                    return [3 /*break*/, 12];
                case 12: return [3 /*break*/, 14];
                case 13:
                    value = param !== null && param !== void 0 ? param : '';
                    _k.label = 14;
                case 14:
                    sanitizedValue = String(value || '');
                    endpoint = endpoint.replace("${".concat(key, "}"), sanitizedValue);
                    _k.label = 15;
                case 15:
                    _i++;
                    return [3 /*break*/, 4];
                case 16: return [3 /*break*/, 18];
                case 17:
                    error_2 = _k.sent();
                    console.error('makeApiCall: Error processing URL parameters:', error_2);
                    react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                    return [2 /*return*/, null];
                case 18:
                    if (!api.payload) return [3 /*break*/, 25];
                    _k.label = 19;
                case 19:
                    _k.trys.push([19, 24, , 25]);
                    _loop_1 = function (key, paramConfig) {
                        var paramValue, eventKey, statePath, handlerFn, handlerArgs, error_9, processNestedObject_1, error_10;
                        return __generator(this, function (_l) {
                            switch (_l.label) {
                                case 0:
                                    paramValue = null;
                                    if (!(typeof paramConfig === 'string')) return [3 /*break*/, 1];
                                    if (paramConfig === '@handlerValue') {
                                        // paramValue = args.value; // Use the new toggle state
                                        paramValue = args.value;
                                    }
                                    else if (paramConfig.startsWith('@event.')) {
                                        eventKey = paramConfig.slice(7);
                                        paramValue = event_1[eventKey];
                                    }
                                    else if (paramConfig.startsWith('@state.')) {
                                        statePath = paramConfig.slice(7);
                                        paramValue = helpers_1.Helper.getNestedValue(state_1.dynamic[rootState_2], statePath);
                                    }
                                    else {
                                        paramValue = paramConfig;
                                    }
                                    return [3 /*break*/, 17];
                                case 1:
                                    if (!(paramConfig && typeof paramConfig === 'object')) return [3 /*break*/, 16];
                                    if (!('action' in paramConfig && paramConfig.action)) return [3 /*break*/, 11];
                                    handlerFn = globalHandlers[paramConfig.action];
                                    if (!handlerFn) {
                                        console.error("makeApiCall: Handler '".concat(paramConfig.action, "' not found for payload key ").concat(key));
                                        return [2 /*return*/, "continue"];
                                    }
                                    _l.label = 2;
                                case 2:
                                    _l.trys.push([2, 9, , 10]);
                                    if (!('type' in paramConfig &&
                                        paramConfig.type === 'redux' &&
                                        'args' in paramConfig)) return [3 /*break*/, 4];
                                    handlerArgs = __assign(__assign({}, paramConfig.args), { rootState: rootState_2 });
                                    context.state = state_1;
                                    return [4 /*yield*/, handlerFn(handlerArgs, context)];
                                case 3:
                                    paramValue = _l.sent();
                                    return [3 /*break*/, 8];
                                case 4:
                                    if (!('args' in paramConfig)) return [3 /*break*/, 6];
                                    return [4 /*yield*/, handlerFn(paramConfig.args, context)];
                                case 5:
                                    paramValue = _l.sent();
                                    return [3 /*break*/, 8];
                                case 6: return [4 /*yield*/, handlerFn({}, context)];
                                case 7:
                                    paramValue = _l.sent();
                                    _l.label = 8;
                                case 8: return [3 /*break*/, 10];
                                case 9:
                                    error_9 = _l.sent();
                                    console.error("makeApiCall: Error executing handler for payload key ".concat(key, ":"), error_9);
                                    return [3 /*break*/, 10];
                                case 10: return [3 /*break*/, 15];
                                case 11:
                                    processNestedObject_1 = function (obj) { return __awaiter(void 0, void 0, void 0, function () {
                                        var result, _i, _a, _b, nestedKey, nestedValue, nestedHandlerFn, handlerArgs, _c, _d, _e, _f, _g, _h, error_11, _j, _k;
                                        return __generator(this, function (_l) {
                                            switch (_l.label) {
                                                case 0:
                                                    result = {};
                                                    _i = 0, _a = Object.entries(obj);
                                                    _l.label = 1;
                                                case 1:
                                                    if (!(_i < _a.length)) return [3 /*break*/, 17];
                                                    _b = _a[_i], nestedKey = _b[0], nestedValue = _b[1];
                                                    if (!(nestedValue && typeof nestedValue === 'object')) return [3 /*break*/, 15];
                                                    if (!('action' in nestedValue && nestedValue.action)) return [3 /*break*/, 11];
                                                    nestedHandlerFn = globalHandlers[nestedValue.action];
                                                    if (!nestedHandlerFn) {
                                                        console.error("makeApiCall: Nested handler '".concat(nestedValue.action, "' not found for payload key ").concat(key, ".").concat(nestedKey));
                                                        result[nestedKey] = null;
                                                        return [3 /*break*/, 16];
                                                    }
                                                    _l.label = 2;
                                                case 2:
                                                    _l.trys.push([2, 9, , 10]);
                                                    if (!('type' in nestedValue &&
                                                        nestedValue.type === 'redux' &&
                                                        'args' in nestedValue)) return [3 /*break*/, 4];
                                                    handlerArgs = __assign(__assign({}, nestedValue.args), { rootState: rootState_2 });
                                                    context.state = state_1;
                                                    _c = result;
                                                    _d = nestedKey;
                                                    return [4 /*yield*/, nestedHandlerFn(handlerArgs, context)];
                                                case 3:
                                                    _c[_d] = _l.sent();
                                                    return [3 /*break*/, 8];
                                                case 4:
                                                    if (!('args' in nestedValue)) return [3 /*break*/, 6];
                                                    _e = result;
                                                    _f = nestedKey;
                                                    return [4 /*yield*/, nestedHandlerFn(nestedValue.args, context)];
                                                case 5:
                                                    _e[_f] = _l.sent();
                                                    return [3 /*break*/, 8];
                                                case 6:
                                                    _g = result;
                                                    _h = nestedKey;
                                                    return [4 /*yield*/, nestedHandlerFn({}, context)];
                                                case 7:
                                                    _g[_h] = _l.sent();
                                                    _l.label = 8;
                                                case 8: return [3 /*break*/, 10];
                                                case 9:
                                                    error_11 = _l.sent();
                                                    console.error("makeApiCall: Error executing nested handler for payload key ".concat(key, ".").concat(nestedKey, ":"), error_11);
                                                    result[nestedKey] = null;
                                                    return [3 /*break*/, 10];
                                                case 10: return [3 /*break*/, 14];
                                                case 11:
                                                    if (!(Object.keys(nestedValue).length > 0)) return [3 /*break*/, 13];
                                                    // Recursively process deeper nested objects
                                                    _j = result;
                                                    _k = nestedKey;
                                                    return [4 /*yield*/, processNestedObject_1(nestedValue)];
                                                case 12:
                                                    // Recursively process deeper nested objects
                                                    _j[_k] = _l.sent();
                                                    return [3 /*break*/, 14];
                                                case 13:
                                                    // Empty object
                                                    result[nestedKey] = nestedValue;
                                                    _l.label = 14;
                                                case 14: return [3 /*break*/, 16];
                                                case 15:
                                                    // Simple value
                                                    result[nestedKey] = nestedValue;
                                                    _l.label = 16;
                                                case 16:
                                                    _i++;
                                                    return [3 /*break*/, 1];
                                                case 17: return [2 /*return*/, result];
                                            }
                                        });
                                    }); };
                                    _l.label = 12;
                                case 12:
                                    _l.trys.push([12, 14, , 15]);
                                    return [4 /*yield*/, processNestedObject_1(paramConfig)];
                                case 13:
                                    paramValue = _l.sent();
                                    return [3 /*break*/, 15];
                                case 14:
                                    error_10 = _l.sent();
                                    console.error("makeApiCall: Error processing nested object for payload key ".concat(key, ":"), error_10);
                                    paramValue = paramConfig;
                                    return [3 /*break*/, 15];
                                case 15: return [3 /*break*/, 17];
                                case 16:
                                    // For direct values
                                    paramValue = paramConfig;
                                    _l.label = 17;
                                case 17:
                                    // Add the parameter, using empty string for null/undefined values
                                    payload[key] =
                                        paramValue !== undefined && paramValue !== null
                                            ? paramValue
                                            : '';
                                    return [2 /*return*/];
                            }
                        });
                    };
                    _c = 0, _d = Object.entries(api.payload);
                    _k.label = 20;
                case 20:
                    if (!(_c < _d.length)) return [3 /*break*/, 23];
                    _e = _d[_c], key = _e[0], paramConfig = _e[1];
                    return [5 /*yield**/, _loop_1(key, paramConfig)];
                case 21:
                    _k.sent();
                    _k.label = 22;
                case 22:
                    _c++;
                    return [3 /*break*/, 20];
                case 23: return [3 /*break*/, 25];
                case 24:
                    error_3 = _k.sent();
                    console.error('makeApiCall: Error processing payload:', error_3);
                    react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                    return [2 /*return*/, null];
                case 25:
                    // Validate API method
                    if (!api.method) {
                        console.error('makeApiCall: Missing HTTP method in api configuration');
                        react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                        return [2 /*return*/, null];
                    }
                    if (args.loaderComponent) {
                        loaderPath_1 = "".concat(args.rootState, ".").concat(args.loaderComponent, "Loading");
                        try {
                            context.dispatch((0, sampleSlice_1.setStateValue)({ path: loaderPath_1, value: true }));
                        }
                        catch (error) {
                            console.error('makeApiCall: Error setting loading state:', error);
                        }
                    }
                    func = Utils[api === null || api === void 0 ? void 0 : api.function] || makeApiCall;
                    loaderPath = "".concat(rootState_2, ".loading");
                    context.dispatch((0, sampleSlice_1.setStateValue)({ path: loaderPath, value: loading }));
                    _k.label = 26;
                case 26:
                    _k.trys.push([26, 28, 29, 30]);
                    return [4 /*yield*/, func(endpoint, api.method, payload || {})];
                case 27:
                    response = _k.sent();
                    return [3 /*break*/, 30];
                case 28:
                    error_4 = _k.sent();
                    console.error('makeApiCall: Error during API request:', error_4);
                    react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                    throw error_4;
                case 29:
                    context.dispatch((0, sampleSlice_1.setStateValue)({ path: loaderPath, value: false }));
                    return [7 /*endfinally*/];
                case 30:
                    if (!response.status) return [3 /*break*/, 37];
                    if (!(api.onSuccess && Array.isArray(api.onSuccess))) return [3 /*break*/, 36];
                    _f = 0, _g = api.onSuccess;
                    _k.label = 31;
                case 31:
                    if (!(_f < _g.length)) return [3 /*break*/, 36];
                    successHandler = _g[_f];
                    if (!successHandler || !successHandler.action) {
                        console.error('makeApiCall: Invalid success handler configuration:', successHandler);
                        return [3 /*break*/, 35];
                    }
                    handlerFn = globalHandlers[successHandler.action];
                    if (!handlerFn) {
                        console.error("makeApiCall: Success handler '".concat(successHandler.action, "' not found"));
                        return [3 /*break*/, 35];
                    }
                    _k.label = 32;
                case 32:
                    _k.trys.push([32, 34, , 35]);
                    nestedValue = helpers_1.Helper.getNestedValue(response, api === null || api === void 0 ? void 0 : api.responseDataKey);
                    handlerValue = 'value' in successHandler.args
                        ? successHandler.args.value
                        : nestedValue || response;
                    return [4 /*yield*/, handlerFn(__assign(__assign({}, successHandler.args), { rootState: rootState_2, value: handlerValue, event: args.event }), context)];
                case 33:
                    _k.sent();
                    return [3 /*break*/, 35];
                case 34:
                    error_5 = _k.sent();
                    console.error("makeApiCall: Error executing success handler '".concat(successHandler.action, "':"), error_5);
                    return [3 /*break*/, 35];
                case 35:
                    _f++;
                    return [3 /*break*/, 31];
                case 36: return [2 /*return*/, response.data];
                case 37: 
                // API returned non-success status
                // console.error(
                //   '++makeApiCall: API returned error status:',
                //   response.message,
                // );
                // toast.error(
                //   response.message ||
                //     'An error occurred. Please contact the administrator.',
                // );
                // Process failure handlers
                throw new Error(response.message || 'API call failed');
                case 38: return [3 /*break*/, 48];
                case 39:
                    error_6 = _k.sent();
                    if (!(api.onFailure && Array.isArray(api.onFailure))) return [3 /*break*/, 46];
                    _h = 0, _j = api.onFailure;
                    _k.label = 40;
                case 40:
                    if (!(_h < _j.length)) return [3 /*break*/, 45];
                    failureHandler = _j[_h];
                    value = void 0;
                    handlerFn = globalHandlers[failureHandler.action];
                    if (failureHandler.action === 'displayToast') {
                        value = response === null || response === void 0 ? void 0 : response.message;
                    }
                    if (!handlerFn) {
                        console.log("++makeApiCall: Failure handler '".concat(failureHandler.action, "' not found"));
                        return [3 /*break*/, 44];
                    }
                    _k.label = 41;
                case 41:
                    _k.trys.push([41, 43, , 44]);
                    handlerArgs = __assign(__assign({}, failureHandler.args), { rootState: rootState_2, value: value || null, event: args.event });
                    return [4 /*yield*/, handlerFn(handlerArgs, context)];
                case 42:
                    value = _k.sent();
                    return [3 /*break*/, 44];
                case 43:
                    error_7 = _k.sent();
                    console.error("makeApiCall: Error executing handler:", error_7);
                    return [3 /*break*/, 44];
                case 44:
                    _h++;
                    return [3 /*break*/, 40];
                case 45: return [2 /*return*/, null];
                case 46: throw error_6;
                case 47:
                    if (args.loaderComponent) {
                        loaderPath = "".concat(args.rootState, ".").concat(args.loaderComponent, "Loading");
                        try {
                            context.dispatch((0, sampleSlice_1.setStateValue)({ path: loaderPath, value: false }));
                        }
                        catch (error) {
                            console.error('makeApiCall: Error resetting loading state:', error);
                        }
                    }
                    return [7 /*endfinally*/];
                case 48: return [3 /*break*/, 50];
                case 49:
                    error_8 = _k.sent();
                    // console.log('makeApiCall: Uncaught error in main function:', error);
                    react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                    return [2 /*return*/, null];
                case 50: return [2 /*return*/];
            }
        });
    }); },
    resetForm: function (args, context) {
        try {
            // Validate input parameters
            if (!args) {
                console.error('resetForm: Missing required args parameter');
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return;
            }
            var value_source = args.value_source;
            // Check if value_source exists
            if (!value_source) {
                console.error('resetForm: Missing value_source in args');
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return;
            }
            // Check if value_source has the required properties
            if (value_source.source !== 'redux') {
                console.error("resetForm: Unsupported value_source.source: ".concat(value_source.source));
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return;
            }
            // Check if stateName is provided
            if (!value_source.stateName) {
                console.error('resetForm: Missing stateName in value_source');
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return;
            }
            // Validate context and dispatch function
            if (!context) {
                console.error('resetForm: Context is undefined or null');
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return;
            }
            if (typeof context.dispatch !== 'function') {
                console.error('resetForm: context.dispatch is not a function');
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return;
            }
            // Reset the form state in Redux
            try {
                context.dispatch((0, sampleSlice_1.setStateValue)({
                    path: value_source.stateName,
                    value: {},
                }));
            }
            catch (dispatchError) {
                console.error('resetForm: Error dispatching setStateValue action:', dispatchError);
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
            }
        }
        catch (error) {
            console.error('resetForm: Unexpected error in function execution:', error);
            react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
        }
    },
    getValueFromLocalStorage: function (args, context) {
        var store = (0, ACWrapperContext_1.getStore)();
        var state = store;
        try {
            // Validate input parameters
            if (!args) {
                console.error('getValueFromLocalStorage: Missing required args parameter');
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return null;
            }
            var storedLocation = args.storedLocation;
            if (!storedLocation) {
                console.error("getValueFromLocalStorage: Missing required 'storedLocation' parameter");
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return null;
            }
            // Split the storage key from the path
            var _a = storedLocation.split('.'), key = _a[0], path = _a.slice(1);
            if (!key) {
                console.error('getValueFromLocalStorage: Empty localStorage key in storedLocation');
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return null;
            }
            // Retrieve data from localStorage
            var storedValue = void 0;
            try {
                storedValue = localStorage.getItem(key);
            }
            catch (error) {
                console.error("getValueFromLocalStorage: Error accessing localStorage for key '".concat(key, "':"), error);
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return null;
            }
            if (storedValue === null) {
                console.warn("getValueFromLocalStorage: No value found in localStorage for key: '".concat(key, "'"));
                // Not showing toast here as this might be an expected case in some scenarios
                return null;
            }
            // Parse JSON data if needed
            var jsonValue = void 0;
            try {
                jsonValue = JSON.parse(storedValue);
            }
            catch (error) {
                console.error("getValueFromLocalStorage: Error parsing JSON for key '".concat(key, "':"), error);
                // If no path is requested, return the raw string
                if (path.length === 0) {
                    return storedValue;
                }
                else {
                    react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                    return null;
                }
            }
            // Return the full object if no path is specified
            if (path.length === 0) {
                return jsonValue;
            }
            // Navigate through the nested path
            try {
                var result = jsonValue;
                for (var i = 0; i < path.length; i++) {
                    var part = path[i];
                    if (result === null || result === undefined) {
                        console.warn("getValueFromLocalStorage: Path traversal failed at '".concat(part, "' in '").concat(storedLocation, "'"));
                        return null;
                    }
                    result = result[part];
                }
                return result;
            }
            catch (error) {
                console.error("getValueFromLocalStorage: Error accessing nested path '".concat(path.join('.'), "' in object:"), error);
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return null;
            }
        }
        catch (error) {
            console.error('getValueFromLocalStorage: Unexpected error in function execution:', error);
            react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
            return null;
        }
    },
    getValueFromLocation: function (args, context) {
        var store = (0, ACWrapperContext_1.getStore)();
        var state = store;
        try {
            // Validate input parameters
            if (!args) {
                console.error('getValueFromLocation: Missing required args parameter');
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return null;
            }
            var pattern = args.pattern, key = args.key;
            if (!key || !pattern) {
                console.error("getValueFromLocation: Missing required 'storedLocation' parameter");
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return null;
            }
            if (!key) {
                console.error('getValueFromLocation: Empty localStorage key in storedLocation');
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return null;
            }
            // console.log(key, pattern);
            // Retrieve data from localStorage
            var storedValue = void 0;
            try {
                storedValue = utils_1.Utils.getParamFromPath(pattern, key) || '';
            }
            catch (error) {
                console.error("getValueFromLocation: Error accessing localStorage for key '".concat(key, "':"), error);
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return null;
            }
            if (storedValue === null) {
                console.warn("getValueFromLocation: No value found in localStorage for key: '".concat(key, "'"));
                // Not showing toast here as this might be an expected case in some scenarios
                return null;
            }
            return storedValue;
        }
        catch (error) {
            console.error('getValueFromLocation: Unexpected error in function execution:', error);
            react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
            return null;
        }
    },
    checkCondition: function (args, context) {
        try {
            // Validate input parameters
            if (!args) {
                console.error('checkCondition: Missing required args parameter');
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return false;
            }
            var condition = args.condition, event_2 = args.event, onSuccess = args.onSuccess, rootState = args.rootState, value = args.value;
            // console.log(
            //   "'checkCondition' function called with condition:",
            //   condition,
            //   event,
            //   value,
            // );
            // If no condition is defined, return true by default
            if (!condition) {
                return true;
            }
            // Validate that condition is a string
            if (typeof condition !== 'string') {
                console.error("checkCondition: Invalid condition type: ".concat(typeof condition, ", expected string"));
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return false;
            }
            // Create and evaluate the condition function
            var conditionFn = void 0;
            try {
                conditionFn = new Function('e', "return ".concat(condition));
            }
            catch (error) {
                console.error("checkCondition: Error creating function from condition string '".concat(condition, "':"), error);
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return false;
            }
            // Evaluate the condition with the event
            var result = void 0;
            try {
                result = conditionFn(value ? { value: value } : event_2);
            }
            catch (error) {
                console.error("checkCondition: Error evaluating condition '".concat(condition, "' with event:"), error);
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return false;
            }
            // Execute success handlers if condition is true
            if (result && onSuccess) {
                if (!Array.isArray(onSuccess)) {
                    console.error('checkCondition: onSuccess is not an array:', onSuccess);
                    react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                }
                else {
                    for (var _i = 0, onSuccess_1 = onSuccess; _i < onSuccess_1.length; _i++) {
                        var handler = onSuccess_1[_i];
                        try {
                            if (!handler || typeof handler !== 'object') {
                                console.error('checkCondition: Invalid handler configuration:', handler);
                                continue;
                            }
                            if (!handler.action) {
                                console.error("checkCondition: Handler missing 'action' property:", handler);
                                continue;
                            }
                            var handlerFn = globalHandlers[handler.action];
                            if (!handlerFn) {
                                console.error("checkCondition: Handler '".concat(handler.action, "' not found in globalHandlers"));
                                continue;
                            }
                            // Prepare handler arguments
                            var handlerArgs = __assign(__assign(__assign({}, args), (handler.args || {})), { event: event_2, rootState: rootState });
                            // Execute the handler
                            handlerFn(handlerArgs, context);
                        }
                        catch (handlerError) {
                            console.error("checkCondition: Error executing success handler '".concat(handler === null || handler === void 0 ? void 0 : handler.action, "':"), handlerError);
                            // Not showing toast here as we don't want multiple toasts for each handler
                        }
                    }
                }
            }
            return !!result; // Convert result to boolean
        }
        catch (error) {
            console.error('checkCondition: Unexpected error in function execution:', error);
            react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
            return false;
        }
    },
    evalCondition: function (args, context) {
        try {
            var condition = args.condition, _a = args.onTrue, onTrue = _a === void 0 ? [] : _a, _b = args.onFalse, onFalse = _b === void 0 ? [] : _b;
            var state = context === null || context === void 0 ? void 0 : context.state;
            // console.log(
            //   '__eval condition_test:',
            //   state.dynamic.billing.form_visibility,
            // );
            var result = false;
            try {
                result = eval(condition);
            }
            catch (e) {
                console.error('evalCondition: Error evaluating condition:', e);
                result = false;
            }
            var handlersToRun = result ? onTrue : onFalse;
            // console.log('__eval condition_result:', result);
            handlersToRun.forEach(function (handler) {
                if (handler && handler.action && globalHandlers[handler.action]) {
                    globalHandlers[handler.action](__assign(__assign({}, handler.args), { rootState: args.rootState }), context);
                }
            });
            return result;
        }
        catch (error) {
            console.error('evalCondition: Unexpected error:', error);
            return false;
        }
    },
    updateArrayItem: function (args, context) {
        var _a, _b;
        try {
            // Validate required parameters
            if (!args || !args.arrayPath) {
                console.error('updateArrayItem: Missing required parameters');
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return;
            }
            // Get all potential value sources
            var arrayPath = args.arrayPath, id = args.id, key_1 = args.key, value = args.value, event_3 = args.event, rootState = args.rootState;
            // console.log('updateArrayItem - Raw args:', args.event);
            // Get the correct ID - handle both string IDs and event objects
            var actualId_1 = (event_3 === null || event_3 === void 0 ? void 0 : event_3.id) || (event_3 === null || event_3 === void 0 ? void 0 : event_3._id) || null;
            var actualValue_1 = event_3 === null || event_3 === void 0 ? void 0 : event_3.is_active;
            // Guard against undefined/null IDs
            if (actualId_1 === undefined || actualId_1 === null) {
                console.error('updateArrayItem: Could not determine item ID');
                return;
            }
            var array = helpers_1.Helper.getNestedValue((_b = (_a = context === null || context === void 0 ? void 0 : context.state) === null || _a === void 0 ? void 0 : _a.dynamic) === null || _b === void 0 ? void 0 : _b[rootState || context.rootState], arrayPath);
            if (!Array.isArray(array)) {
                console.error('updateArrayItem: Target is not an array', {
                    arrayPath: arrayPath,
                    found: array,
                });
                return;
            }
            // Create an updated array with the item changed
            var updatedArray = array.map(function (item) {
                var _a;
                if (item.id === actualId_1 || item.id === Number(actualId_1)) {
                    return __assign(__assign({}, item), (_a = {}, _a[key_1] = actualValue_1, _a));
                }
                return item;
            });
            // Dispatch the state update
            context.dispatch((0, sampleSlice_1.setStateValue)({
                path: "".concat(rootState || context.rootState, ".").concat(arrayPath),
                value: updatedArray,
            }));
        }
        catch (error) {
            console.error('updateArrayItem: Unexpected error:', error);
            react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
        }
    },
    execFunction: function (args, context) {
        try {
            var condition = args.condition, _a = args.onTrue, onTrue = _a === void 0 ? [] : _a, _b = args.onFalse, onFalse = _b === void 0 ? [] : _b, event_4 = args.event, value = args.value;
            var rootState = context.rootState;
            var transformedCondition = /@state\??/.test(condition)
                ? condition.replace(/@state\??/g, "state?.dynamic?.".concat(rootState))
                : condition;
            var state = context.state, dispatch = context.dispatch;
            var result = false;
            try {
                var fn = new Function('state', 'dispatch', 'setStateValue', 'e', transformedCondition);
                result = fn(state, dispatch, sampleSlice_1.setStateValue, value ? { value: value } : event_4);
            }
            catch (e) {
                console.error('evalCondition: Error evaluating condition:', e);
                result = false;
            }
            var handlersToRun = result ? onTrue : onFalse;
            handlersToRun.forEach(function (handler) {
                if (handler && handler.action && globalHandlers[handler.action]) {
                    globalHandlers[handler.action](__assign(__assign(__assign({}, args), handler.args), { rootState: args.rootState, event: event_4 }), context);
                }
            });
            return result;
        }
        catch (error) {
            console.error('execFunction: Unexpected error:', error);
            return false;
        }
    },
    validateForm: function (args, context) {
        var _a, _b;
        try {
            var _c = args.onTrue, onTrue = _c === void 0 ? [] : _c, _d = args.onFalse, onFalse = _d === void 0 ? [] : _d, event_5 = args.event, value_2 = args.value, schema = args.schema, rootState_3 = args.rootState, _e = args.tables, tables = _e === void 0 ? [] : _e;
            var state_2 = context.state, dispatch_1 = context.dispatch;
            var formIsValid = true;
            if (Array.isArray(tables) && tables.length > 0) {
                var _loop_2 = function (tableConfig) {
                    var tbodySource = tableConfig.tbodySource, theadSource = tableConfig.theadSource, _f = tableConfig.component, component = _f === void 0 ? 'table' : _f, componentName = tableConfig.componentName;
                    if (!tbodySource || !tbodySource.storedLocation) {
                        console.warn('validateForm: Missing tbodySource.storedLocation for table validation');
                        return "continue";
                    }
                    var tableData = helpers_1.Helper.getNestedValue((_a = state_2 === null || state_2 === void 0 ? void 0 : state_2.dynamic) === null || _a === void 0 ? void 0 : _a[rootState_3 || context.rootState], tbodySource.storedLocation);
                    if (!tableData ||
                        !Array.isArray(tableData) ||
                        tableData.length === 0) {
                        return "continue";
                    }
                    var theadData = void 0;
                    if (theadSource) {
                        if (theadSource.storedLocation) {
                            theadData = helpers_1.Helper.getNestedValue((_b = state_2 === null || state_2 === void 0 ? void 0 : state_2.dynamic) === null || _b === void 0 ? void 0 : _b[rootState_3 || context.rootState], theadSource.storedLocation);
                        }
                        else if (Array.isArray(theadSource)) {
                            theadData = theadSource;
                        }
                    }
                    else if (componentName && schema) {
                        var findComponent_1 = function (fields) {
                            if (!Array.isArray(fields))
                                return null;
                            for (var _i = 0, fields_1 = fields; _i < fields_1.length; _i++) {
                                var field = fields_1[_i];
                                if (field.name === componentName) {
                                    return field;
                                }
                                if (Array.isArray(field.fields) && field.fields.length > 0) {
                                    var found = findComponent_1(field.fields);
                                    if (found)
                                        return found;
                                }
                            }
                            return null;
                        };
                        var component_1 = findComponent_1(schema);
                        if (component_1 &&
                            component_1.thead &&
                            Array.isArray(component_1.thead)) {
                            theadData = component_1.thead;
                        }
                    }
                    if (!theadData || !Array.isArray(theadData)) {
                        console.warn("validateForm: No thead configuration found for table ".concat(component));
                        return "continue";
                    }
                    var requiredColumns = theadData.reduce(function (acc, column) {
                        if (column.required === true) {
                            var columnId = column.name || column.key;
                            if (columnId) {
                                acc[columnId] = {
                                    id: columnId,
                                    label: column.title || column.label || columnId,
                                };
                            }
                        }
                        return acc;
                    }, {});
                    if (Object.keys(requiredColumns).length === 0) {
                        return "continue";
                    }
                    var tableValid = true;
                    var firstErrorMessage = '';
                    tableData.forEach(function (row, rowIndex) {
                        Object.values(requiredColumns).forEach(function (column) {
                            var value = row[column.id];
                            var isEmpty = value === undefined ||
                                value === null ||
                                value === '' ||
                                (Array.isArray(value) && value.length === 0) ||
                                (typeof value === 'object' &&
                                    !Array.isArray(value) &&
                                    Object.keys(value).length === 0);
                            if (isEmpty && tableValid) {
                                tableValid = false;
                                firstErrorMessage = "".concat(column.label, " is required in row ").concat(rowIndex + 1);
                            }
                        });
                    });
                    if (!tableValid) {
                        formIsValid = false;
                        react_toastify_1.toast.error(firstErrorMessage);
                    }
                };
                for (var _i = 0, tables_1 = tables; _i < tables_1.length; _i++) {
                    var tableConfig = tables_1[_i];
                    _loop_2(tableConfig);
                }
            }
            if ((schema === null || schema === void 0 ? void 0 : schema.length) && formIsValid) {
                var evaluate_1 = function (condition) {
                    var result = false;
                    var transformedCondition = /@state\??/.test(condition)
                        ? condition.replace(/@state\??/g, "state.dynamic.".concat(rootState_3))
                        : condition;
                    try {
                        var fn = new Function('state', 'dispatch', 'setStateValue', 'e', transformedCondition);
                        result = fn(state_2, dispatch_1, context.setStateValue, value_2 ? { value: value_2 } : event_5);
                    }
                    catch (e) {
                        console.error('validateForm: Error evaluating condition:', e);
                        result = false;
                    }
                    return result;
                };
                var checkVisible_1 = function (field) {
                    if (field === null || field === void 0 ? void 0 : field.visibleCondition) {
                        return evaluate_1(field === null || field === void 0 ? void 0 : field.visibleCondition);
                    }
                    else if ((field === null || field === void 0 ? void 0 : field.visible) === false) {
                        return false;
                    }
                    return true;
                };
                var hasError_1 = false;
                var toastError_1 = function (field) {
                    react_toastify_1.toast.error("".concat((field === null || field === void 0 ? void 0 : field.label) || (field === null || field === void 0 ? void 0 : field.errorText) || (field === null || field === void 0 ? void 0 : field.name), " is required"), {
                        style: {
                            justifyContent: 'start',
                        },
                    });
                    hasError_1 = true;
                };
                var recurse_1 = function (fields) {
                    var _a, _b, _c, _d;
                    for (var _i = 0, fields_2 = fields; _i < fields_2.length; _i++) {
                        var field = fields_2[_i];
                        var isVisible = checkVisible_1(field);
                        if (isVisible) {
                            if (Array.isArray(field === null || field === void 0 ? void 0 : field.fields) && ((_a = field === null || field === void 0 ? void 0 : field.fields) === null || _a === void 0 ? void 0 : _a.length)) {
                                recurse_1(field.fields);
                            }
                            else if (field === null || field === void 0 ? void 0 : field.required) {
                                var path = (_b = field === null || field === void 0 ? void 0 : field.valueSource) === null || _b === void 0 ? void 0 : _b.storedLocation;
                                if (path) {
                                    var value_3 = helpers_1.Helper.getNestedValue((_c = state_2 === null || state_2 === void 0 ? void 0 : state_2.dynamic) === null || _c === void 0 ? void 0 : _c[rootState_3 || context.rootState || ''], path);
                                    var plainInputs = [
                                        'input-text',
                                        'datepicker',
                                        'radio',
                                        'textarea',
                                    ];
                                    if (plainInputs.includes(field === null || field === void 0 ? void 0 : field.element)) {
                                        if (!(value_3 === null || value_3 === void 0 ? void 0 : value_3.trim())) {
                                            toastError_1(field);
                                            break;
                                        }
                                    }
                                    else if ((field === null || field === void 0 ? void 0 : field.element) === 'input-number') {
                                        if (value_3 !== 0 && !value_3) {
                                            toastError_1(field);
                                            break;
                                        }
                                    }
                                    else if ((field === null || field === void 0 ? void 0 : field.element) === 'text-editor') {
                                        var rawValue = value_3 || '';
                                        var strippedText = rawValue
                                            .replace(/<(.|\n)*?>/g, '')
                                            .trim();
                                        if (!strippedText) {
                                            toastError_1(field);
                                            break;
                                        }
                                    }
                                    else if ((field === null || field === void 0 ? void 0 : field.element) === 'single-select') {
                                        var singleCondition = (field === null || field === void 0 ? void 0 : field.mode) !== 'multiple' &&
                                            (!value_3 || ((_d = Object.keys(value_3)) === null || _d === void 0 ? void 0 : _d.length) === 0);
                                        var multipleCondition = (field === null || field === void 0 ? void 0 : field.mode) === 'multiple' &&
                                            (!(Array === null || Array === void 0 ? void 0 : Array.isArray(value_3)) || value_3.length === 0);
                                        if (singleCondition || multipleCondition) {
                                            toastError_1(field);
                                            break;
                                        }
                                    }
                                    else if ((field === null || field === void 0 ? void 0 : field.element) === 'checkbox-group') {
                                        if (!Array.isArray(value_3) || (value_3 === null || value_3 === void 0 ? void 0 : value_3.length) === 0) {
                                            toastError_1(field);
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }
                };
                recurse_1(schema);
                formIsValid = formIsValid && !hasError_1;
            }
            var handlersToRun = formIsValid ? onTrue : onFalse;
            if (Array.isArray(handlersToRun)) {
                handlersToRun.forEach(function (handler) {
                    if ((handler === null || handler === void 0 ? void 0 : handler.action) && (globalHandlers === null || globalHandlers === void 0 ? void 0 : globalHandlers[handler.action])) {
                        globalHandlers[handler.action](__assign(__assign(__assign({}, args), handler.args), { rootState: rootState_3 || context.rootState, event: event_5 }), context);
                    }
                });
            }
            return formIsValid;
        }
        catch (error) {
            console.error('validateForm: Unexpected error:', error);
            react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
            return false;
        }
    },
    resetAndInitializeState: function (args, context) {
        var _a, _b, _c;
        var resetHelper = function (rootState, currentSchema) {
            var initialStates = currentSchema.initial_states || {};
            Object.entries(initialStates).forEach(function (_a) {
                var key = _a[0], value = _a[1];
                // Handle states with handler functions
                if (typeof value === 'object' && (value === null || value === void 0 ? void 0 : value.action)) {
                    var handler = globalHandlers[value.action];
                    if (handler) {
                        var result = handler(value.args, context);
                        context.dispatch((0, sampleSlice_1.setStateValue)({
                            path: "".concat(rootState, ".").concat(key),
                            value: result,
                        }));
                    }
                }
                else {
                    // Handle direct value assignment
                    context.dispatch((0, sampleSlice_1.setStateValue)({
                        path: "".concat(rootState, ".").concat(key),
                        value: value,
                    }));
                }
            });
        };
        try {
            // Validate required parameters
            var rootStates = args.rootStates, rootState_4 = args.rootState, schema = args.schema, stateNames = args.stateNames;
            // Validate context and dispatch function
            if (!context || typeof context.dispatch !== 'function') {
                console.error('resetAndInitializeState: Context or dispatch function is missing');
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return;
            }
            // NEW: Handle stateNames parameter (targeted reset of specific properties)
            if (rootState_4 && Array.isArray(stateNames) && stateNames.length > 0) {
                // Find the schema for the rootState
                var currentSchema = schema ||
                    ((_a = context === null || context === void 0 ? void 0 : context.schema) === null || _a === void 0 ? void 0 : _a.find(function (item) { return item.name === rootState_4; }));
                if (!currentSchema) {
                    console.warn("resetAndInitializeState: Could not find schema for '".concat(rootState_4, "', skipping targeted reset"));
                    return;
                }
                // Get initial states
                var initialStates = currentSchema.initial_states || {};
                // Reset only the specified state names
                for (var _i = 0, stateNames_1 = stateNames; _i < stateNames_1.length; _i++) {
                    var stateName = stateNames_1[_i];
                    if (initialStates && initialStates.hasOwnProperty(stateName)) {
                        var initialValue = initialStates[stateName];
                        // Handle states with handler functions
                        if (typeof initialValue === 'object' && (initialValue === null || initialValue === void 0 ? void 0 : initialValue.action)) {
                            var handler = globalHandlers[initialValue.action];
                            if (handler) {
                                var result = handler(initialValue.args, context);
                                context.dispatch((0, sampleSlice_1.setStateValue)({
                                    path: "".concat(rootState_4, ".").concat(stateName),
                                    value: result,
                                }));
                            }
                        }
                        else {
                            // Handle direct value assignment
                            context.dispatch((0, sampleSlice_1.setStateValue)({
                                path: "".concat(rootState_4, ".").concat(stateName),
                                value: initialValue,
                            }));
                        }
                    }
                    else {
                        // If no initial state is defined, set to empty object
                        context.dispatch((0, sampleSlice_1.setStateValue)({
                            path: "".concat(rootState_4, ".").concat(stateName),
                            value: {},
                        }));
                    }
                }
                return true;
            }
            // Process multiple rootStates (array version)
            if (Array.isArray(rootStates) && rootStates.length > 0) {
                // Step 1: Reset all specified rootStates
                context.dispatch((0, sampleSlice_1.resetState)({ pages: rootStates }));
                var _loop_3 = function (currentRootState) {
                    // Find the schema for the current rootState
                    var currentSchema = schema ||
                        ((_b = context === null || context === void 0 ? void 0 : context.schema) === null || _b === void 0 ? void 0 : _b.find(function (item) { return item.name === currentRootState; }));
                    if (!currentSchema) {
                        console.warn("resetAndInitializeState: Could not find schema for '".concat(currentRootState, "', skipping initialization"));
                        return "continue";
                    }
                    // Step 3: Re-initialize with initial states from schema
                    resetHelper(currentRootState, currentSchema);
                };
                // Step 2: Initialize each rootState with its initial_states
                for (var _d = 0, rootStates_1 = rootStates; _d < rootStates_1.length; _d++) {
                    var currentRootState = rootStates_1[_d];
                    _loop_3(currentRootState);
                }
            }
            // Process single rootState (backward compatibility)
            else if (rootState_4) {
                // Step 1: Reset the state for this rootState
                context.dispatch((0, sampleSlice_1.resetState)({ page: rootState_4 }));
                // Step 2: Find the schema with initial_states
                var rootSchema = schema ||
                    ((_c = context === null || context === void 0 ? void 0 : context.schema) === null || _c === void 0 ? void 0 : _c.find(function (item) { return item.name === rootState_4; }));
                if (!rootSchema) {
                    console.error("resetAndInitializeState: Could not find schema for '".concat(rootState_4, "'"));
                    react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                    return;
                }
                // Step 3: Re-initialize with initial states from schema
                resetHelper(rootState_4, rootSchema);
                // console.log(
                //   `State for ${rootState} has been reset and reinitialized with initial values`,
                // );
            }
            // If no rootState or rootStates provided, reset all states
            else {
                // Reset all states without specifying any pages
                context.dispatch((0, sampleSlice_1.resetState)({}));
                // console.log('All states have been reset');
            }
            return true;
        }
        catch (error) {
            console.error('resetAndInitializeState: Unexpected error in function execution:', error);
            react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
            return false;
        }
    },
    getValueFromEvent: function (args, context) {
        try {
            // Validate input parameters
            if (!args) {
                // console.error('getValueFromEvent: Missing required args parameter');
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return null;
            }
            // Initialize variables
            var value = args.event;
            // Check if event exists
            if (value === undefined || value === null) {
                console.warn('getValueFromEvent: Event is undefined or null');
                // Not throwing error here as this might be intentional in some cases
            }
            // Process location path if specified
            if (args.location) {
                try {
                    if (typeof args.location !== 'string') {
                        console.error("getValueFromEvent: Invalid location type: ".concat(typeof args.location, ", expected string"));
                        react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                        return null;
                    }
                    // Split the path by dots to navigate nested objects
                    var path = args.location.split('.');
                    // Traverse the path to get the value
                    for (var _i = 0, path_1 = path; _i < path_1.length; _i++) {
                        var key = path_1[_i];
                        if (value === null || value === undefined) {
                            console.warn("getValueFromEvent: Path traversal failed at '".concat(key, "' in '").concat(args.location, "'"));
                            // Not showing toast here as this might be an expected case in some scenarios
                            return null;
                        }
                        // Check if the key exists in the object
                        if (typeof value === 'object' && !(key in value)) {
                            console.error("getValueFromEvent: Key '".concat(key, "' not found in object while traversing '").concat(args.location, "'"));
                            // Not showing toast here as this might be an expected case in some scenarios
                            return null;
                        }
                        value = value[key];
                    }
                }
                catch (error) {
                    console.error("getValueFromEvent: Error extracting value from path '".concat(args.location, "':"), error);
                    react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                    return null;
                }
            }
            // Process success handlers if they exist
            if (args.onSuccess) {
                try {
                    if (!Array.isArray(args.onSuccess)) {
                        // console.error(
                        //   'getValueFromEvent: onSuccess is not an array:',
                        //   args.onSuccess,
                        // );
                        react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                    }
                    else {
                        for (var _a = 0, _b = args.onSuccess; _a < _b.length; _a++) {
                            var successHandler = _b[_a];
                            try {
                                // Validate handler structure
                                if (!successHandler || typeof successHandler !== 'object') {
                                    console.error('getValueFromEvent: Invalid success handler:', successHandler);
                                    continue;
                                }
                                if (!successHandler.action) {
                                    console.error("getValueFromEvent: Missing 'action' in success handler:", successHandler);
                                    continue;
                                }
                                var handlerFn = globalHandlers[successHandler.action];
                                if (!handlerFn) {
                                    console.error("getValueFromEvent: Handler '".concat(successHandler.action, "' not found in globalHandlers"));
                                    continue;
                                }
                                // Prepare handler value and arguments
                                var handlerValue = 'value' in (successHandler.args || {})
                                    ? successHandler.args.value
                                    : value;
                                var handlerArgs = __assign(__assign({}, (successHandler.args || {})), { rootState: args.rootState, value: handlerValue });
                                // Execute the handler
                                handlerFn(handlerArgs, context);
                            }
                            catch (handlerError) {
                                console.error("getValueFromEvent: Error executing success handler '".concat(successHandler === null || successHandler === void 0 ? void 0 : successHandler.action, "':"), handlerError);
                                // Not showing toast here to avoid multiple toasts for each handler
                            }
                        }
                    }
                }
                catch (handlersError) {
                    console.error('getValueFromEvent: Error processing success handlers:', handlersError);
                    react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                }
            }
            return value;
        }
        catch (error) {
            console.error('getValueFromEvent: Unexpected error in function execution:', error);
            react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
            return null;
        }
    },
    updateModalData: function (args, context) {
        // console.log('updateModalData', args);
        try {
            // Validate input parameters
            if (!args) {
                console.error('updateModalData: Missing required args parameter');
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return;
            }
            var value_4 = args.value, _a = args.title, title_1 = _a === void 0 ? '' : _a;
            // Validate value exists and has required structure
            if (!value_4) {
                console.error("updateModalData: Missing required 'value' parameter in args");
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return;
            }
            if (!value_4.data) {
                console.error("updateModalData: Missing 'data' in value object");
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return;
            }
            if (!value_4.data.headings_and_contents ||
                !Array.isArray(value_4.data.headings_and_contents)) {
                console.error("updateModalData: Missing or invalid 'headings_and_contents' array in value.data");
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return;
            }
            // Validate context
            if (!context) {
                console.error('updateModalData: Context is undefined or null');
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return;
            }
            if (typeof context.setSchema !== 'function') {
                console.error('updateModalData: context.setSchema is not a function');
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return;
            }
            context.setSchema(function (prev) {
                try {
                    // Make sure prev is an array and contains at least one item
                    if (!Array.isArray(prev)) {
                        console.error('updateModalData: Previous schema is not an array:', prev);
                        react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                        return prev;
                    }
                    if (prev.length === 0) {
                        console.error('updateModalData: Previous schema array is empty');
                        react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                        return prev;
                    }
                    // Clone the previous state to avoid direct mutations
                    var updatedSchema = __spreadArray([], prev, true);
                    // Find and update the modal container
                    try {
                        updatedSchema.forEach(function (section, sectionIndex) {
                            if (!section) {
                                console.error("updateModalData: Invalid section at index ".concat(sectionIndex));
                                return;
                            }
                            if (!section.fields || !Array.isArray(section.fields)) {
                                console.error("updateModalData: Missing or invalid fields array in section at index ".concat(sectionIndex));
                                return;
                            }
                            section.fields = section.fields.map(function (field, fieldIndex) {
                                if (!field) {
                                    console.error("updateModalData: Invalid field at index ".concat(fieldIndex, " in section ").concat(sectionIndex));
                                    return field;
                                }
                                if (field.name === 'table_modal_container') {
                                    try {
                                        // Set modal visibility
                                        field.visible = true;
                                        if (!field.fields || !Array.isArray(field.fields)) {
                                            console.error('updateModalData: Missing or invalid fields array in table_modal_container');
                                            return field;
                                        }
                                        field.fields = field.fields.map(function (modalField, modalFieldIndex) {
                                            if (!modalField) {
                                                console.error("updateModalData: Invalid modal field at index ".concat(modalFieldIndex));
                                                return modalField;
                                            }
                                            if (modalField.name === 'table_modal') {
                                                try {
                                                    if (!modalField.fields ||
                                                        !Array.isArray(modalField.fields)) {
                                                        console.error('updateModalData: Missing or invalid fields array in table_modal');
                                                        return modalField;
                                                    }
                                                    modalField.fields = modalField.fields.map(function (modalContent, contentIndex) {
                                                        if (!modalContent) {
                                                            console.error("updateModalData: Invalid modal content at index ".concat(contentIndex));
                                                            return modalContent;
                                                        }
                                                        // Update modal body
                                                        if (modalContent.name === 'modal_body') {
                                                            try {
                                                                if (value_4.data.type === 'form') {
                                                                    modalContent.fields =
                                                                        value_4.data.headings_and_contents
                                                                            .map(function (item, index) {
                                                                            if (!item) {
                                                                                console.error("updateModalData: Invalid item at index ".concat(index, " in headings_and_contents"));
                                                                                return null;
                                                                            }
                                                                            return {
                                                                                name: "hospital_data_".concat(index + 1),
                                                                                className: 'flex flex-col gap-1',
                                                                                fields: [
                                                                                    {
                                                                                        name: "hospital_data_".concat(index + 1, "_heading"),
                                                                                        element: 'div',
                                                                                        label: item.heading || 'Unknown',
                                                                                        className: 'font-semibold text-lg text-black',
                                                                                    },
                                                                                    {
                                                                                        name: "hospital_data_".concat(index + 1, "_value"),
                                                                                        element: 'div',
                                                                                        label: item.content || '---',
                                                                                        className: 'font-base sm text-gray-4',
                                                                                    },
                                                                                ],
                                                                            };
                                                                        })
                                                                            .filter(Boolean);
                                                                }
                                                                else if (value_4.data.type === 'pdf') {
                                                                    modalContent.fields = [
                                                                        {
                                                                            name: 'preview_content',
                                                                            element: 'div',
                                                                            label: value_4.data.trainedData,
                                                                            className: 'font-base text-sm text-black whitespace-pre',
                                                                        },
                                                                    ];
                                                                }
                                                                // Create fields for each heading and content
                                                                // Remove any null entries
                                                            }
                                                            catch (bodyError) {
                                                                console.error('updateModalData: Error updating modal body:', bodyError);
                                                                // Don't throw, just return the original content
                                                                return modalContent;
                                                            }
                                                        }
                                                        // Update modal title
                                                        if (modalContent.name === 'modal_title') {
                                                            try {
                                                                if (!modalContent.fields ||
                                                                    !Array.isArray(modalContent.fields)) {
                                                                    console.error('updateModalData: Missing or invalid fields array in modal_title');
                                                                    return modalContent;
                                                                }
                                                                modalContent.fields =
                                                                    modalContent.fields.map(function (titleField, titleIndex) {
                                                                        if (!titleField) {
                                                                            console.error("updateModalData: Invalid title field at index ".concat(titleIndex));
                                                                            return titleField;
                                                                        }
                                                                        if (titleField.name ===
                                                                            'modal_title_key') {
                                                                            titleField.label = title_1;
                                                                        }
                                                                        return titleField;
                                                                    });
                                                            }
                                                            catch (titleError) {
                                                                console.error('updateModalData: Error updating modal title:', titleError);
                                                                // Don't throw, just return the original content
                                                                return modalContent;
                                                            }
                                                        }
                                                        return modalContent;
                                                    });
                                                }
                                                catch (modalFieldsError) {
                                                    console.error('updateModalData: Error processing table_modal fields:', modalFieldsError);
                                                    return modalField;
                                                }
                                            }
                                            return modalField;
                                        });
                                    }
                                    catch (containerError) {
                                        console.error('updateModalData: Error processing table_modal_container:', containerError);
                                        return field;
                                    }
                                }
                                return field;
                            });
                        });
                        return updatedSchema;
                    }
                    catch (sectionError) {
                        console.error('updateModalData: Error processing schema sections:', sectionError);
                        react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                        return prev;
                    }
                }
                catch (schemaError) {
                    console.error('updateModalData: Error in schema update function:', schemaError);
                    react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                    return prev;
                }
            });
        }
        catch (error) {
            console.error('updateModalData: Uncaught error in function execution:', error);
            react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
        }
    },
    navigate: function (args, context) {
        // Use getNavigate() instead of useNavigate() hook
        try {
            // Validate input parameters
            if (!args) {
                console.error('navigate: Missing required args parameter');
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return;
            }
            var route = args.route, params = args.params, rootState_5 = args.rootState;
            // Validate route
            if (!route) {
                console.error('navigate: No route provided for navigation');
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return;
            }
            // Validate context
            if (!context) {
                console.error('navigate: Context is undefined or null');
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return;
            }
            // Check if context has navigate function
            if (typeof context.navigate !== 'function') {
                console.error('navigate: context.navigate is not a function');
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return;
            }
            // Handle route with dynamic parameters
            var finalRoute_1 = route;
            // Process dynamic parameters if they exist
            if (params) {
                try {
                    Object.entries(params).forEach(function (_a) {
                        var key = _a[0], paramConfig = _a[1];
                        try {
                            if (paramConfig && typeof paramConfig === 'object') {
                                // Handle event-based parameters
                                if (['redux', 'event'].includes(paramConfig.type) && paramConfig.action) {
                                    var handlerFn = globalHandlers[paramConfig.action];
                                    if (!handlerFn) {
                                        console.error("navigate: Handler '".concat(paramConfig.action, "' not found in globalHandlers"));
                                        return; // Continue with other parameters
                                    }
                                    // Prepare handler arguments
                                    var handlerArgs = __assign(__assign({}, paramConfig.args), { rootState: rootState_5, event: args.value && args.value.value
                                            ? args.value.value
                                            : args.event });
                                    // Call the handler function
                                    var paramValue = void 0;
                                    try {
                                        paramValue = handlerFn(handlerArgs, context);
                                    }
                                    catch (handlerError) {
                                        console.error("navigate: Error executing handler '".concat(paramConfig.action, "':"), handlerError);
                                        return; // Continue with other parameters
                                    }
                                    // Check if paramValue is undefined or null before using it
                                    var valueToUse = paramValue !== undefined && paramValue !== null
                                        ? paramValue
                                        : '';
                                    finalRoute_1 = finalRoute_1.replace("${".concat(key, "}"), valueToUse);
                                }
                                else {
                                    console.warn("navigate: Unsupported parameter config for '".concat(key, "':"), paramConfig);
                                }
                            }
                            else {
                                // Handle direct parameter values
                                var valueToUse = paramConfig || '';
                                finalRoute_1 = finalRoute_1.replace("${".concat(key, "}"), valueToUse);
                            }
                        }
                        catch (paramError) {
                            console.error("navigate: Error processing parameter '".concat(key, "':"), paramError);
                            // Continue with other parameters
                        }
                    });
                }
                catch (paramsError) {
                    console.error('navigate: Error processing parameters object:', paramsError);
                    react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                    return;
                }
            }
            // Check if finalRoute is valid
            if (!finalRoute_1) {
                console.error('navigate: Final route is empty after parameter processing');
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return;
            }
            // Execute navigation
            try {
                context.navigate(finalRoute_1);
            }
            catch (navigationError) {
                console.error('navigate: Navigation execution failed:', navigationError);
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
            }
        }
        catch (error) {
            console.error('navigate: Unexpected error in function execution:', error);
            react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
        }
    },
    getFormattedDate: function (args, context) {
        var format = args.format;
        return {
            values: [
                (0, moment_1.default)().format(format || 'DD-MM-YYYY'),
                (0, moment_1.default)().format(format || 'DD-MM-YYYY'),
            ],
            segmentedValue: 'TD', // Default to Today
        };
    },
    useUtils: function (args, context) {
        var Utils = (0, ACWrapperContext_2.getUtils)();
        try {
            // Validate input parameters
            if (!args) {
                console.error('useUtils: Missing required args parameter');
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return;
            }
            var handlerName = args.handlerName, handlerArgs = args.args, value = args.value;
            // Validate handlerName
            if (!handlerName) {
                console.error("useUtils: Missing required 'handlerName' parameter");
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return;
            }
            if (typeof handlerName !== 'string') {
                console.error("useUtils: Invalid handlerName type: ".concat(typeof handlerName, ", expected string"));
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return;
            }
            // Validate Utils object
            if (!Utils) {
                console.error('useUtils: Utils object is undefined');
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return;
            }
            // Check if the requested handler exists in Utils
            if (!(handlerName in Utils)) {
                console.error("useUtils: Handler '".concat(handlerName, "' not found in Utils object"));
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return;
            }
            // Validate args and value for specific handlers
            if (handlerName === 'exportToExcel' || handlerName === 'exportToCsv') {
                // Check if handlerArgs exists
                if (!handlerArgs) {
                    console.error("useUtils: Missing required 'args' for ".concat(handlerName));
                    react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                    return;
                }
                // Check if thead is available in handlerArgs
                if (!handlerArgs.thead) {
                    console.error("useUtils: Missing required 'thead' in args for ".concat(handlerName));
                    react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                    return;
                }
                // Check if value and value.data exist
                if (!value || !value.data) {
                    console.error("useUtils: Missing required 'value.data' for ".concat(handlerName));
                    react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                    return;
                }
                // Check if fileName is available
                if (!handlerArgs.fileName) {
                    console.warn("useUtils: 'fileName' not provided for ".concat(handlerName, ", using default"));
                    // Not showing toast as this is just a warning
                }
            }
            // Safely access and execute the utility function
            try {
                // Use a type assertion to call the function with the correct parameter types
                var utilFunction = Utils[handlerName];
                // Check if utilFunction is actually a function
                if (typeof utilFunction !== 'function') {
                    console.error("useUtils: '".concat(handlerName, "' exists in Utils but is not a function"));
                    react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                    return;
                }
                // Execute the function with appropriate parameters based on the handler
                if (handlerName === 'exportToExcel' || handlerName === 'exportToCsv') {
                    utilFunction(handlerArgs.thead, value.data, handlerArgs.fileName || 'exported_data');
                }
                else {
                    // For other utility functions, pass all available parameters
                    utilFunction(handlerArgs, value, context);
                }
            }
            catch (executionError) {
                console.error("useUtils: Error executing '".concat(handlerName, "':"), executionError);
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return;
            }
        }
        catch (error) {
            console.error('useUtils: Unexpected error in function execution:', error);
            react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
            var handlerName = args.handlerName;
            if (handlerName &&
                typeof handlerName === 'string' &&
                handlerName in Utils) {
                // Use a type assertion to call the function with the correct parameter types
                var utilFunction = Utils[handlerName];
                utilFunction(args.args.thead, args.value.data, args.args.fileName);
            }
            else {
            }
        }
    },
    setCurrentDateTime: function (args, context) {
        context.dispatch(context.setStateValue({
            path: "".concat(args.rootState, ".currentDateTime"),
            value: (0, moment_1.default)().format('DD-MM-YYYY HH:mm:ss'),
        }));
        return 'Current date and time set successfully!';
    },
    displayToast: function (args) {
        var message = args.message, value = args.value, _a = args.type, type = _a === void 0 ? 'error' : _a;
        var toastMap = {
            success: react_toastify_1.toast.success,
            error: react_toastify_1.toast.error,
            info: react_toastify_1.toast.info,
            warning: react_toastify_1.toast.warning,
            warn: react_toastify_1.toast.warn,
            default: react_toastify_1.toast,
        };
        var toastFn = toastMap[type] || toastMap.default;
        toastFn(message || value, {
            position: 'top-right',
            style: {
                justifyContent: 'start',
            },
        });
    },
    testFunction: function (args, context) {
        // Perform any additional logic here
        // console.log('Test function executed with args:', args);
        return 'Test function executed successfully!';
    },
    addNewRowBilling: function (args, context) {
        // console.log('::Add Billing executed with args:', args);
        // console.log('::Add ', context.rootState);
        var event = (args === null || args === void 0 ? void 0 : args.event) || {};
        // if(event?.index ===)
        return 'Test function executed successfully!';
    },
    startTimer: function (args, context) {
        var seconds = args.seconds, storedLocation = args.storedLocation, rootState = args.rootState;
        if (!storedLocation || !rootState) {
            console.error("startTimer: Missing required 'storedLocation' or 'rootState'");
            return;
        }
        // Set initial timer value
        context.dispatch((0, sampleSlice_1.setStateValue)({
            path: "".concat(rootState, ".").concat(storedLocation),
            value: seconds || 60,
        }));
        var remainingSeconds = seconds || 60;
        // Start countdown
        var countdown = function () {
            if (remainingSeconds > 1) {
                remainingSeconds--;
                context.dispatch((0, sampleSlice_1.setStateValue)({
                    path: "".concat(rootState, ".").concat(storedLocation),
                    value: remainingSeconds,
                }));
                setTimeout(countdown, 1000);
            }
            else {
                context.dispatch((0, sampleSlice_1.setStateValue)({
                    path: "".concat(rootState, ".").concat(storedLocation),
                    value: 0,
                }));
            }
        };
        setTimeout(countdown, 1000);
    },
};
exports.default = globalHandlers;
